export const ZOOM_IN = 'zoomIn';
export const ZOOM_OUT = 'zoomOut';
export const ZOOM_FIT = 'zoomFit';

export const ZOOM_FACTOR = 1.5;

export const MIN_SCALE = 0.01;
export const MAX_SCALE = 3;
export const MIN_SCALE_MOBILE = 0.1;
export const MAX_SCALE_MOBILE = 1.3;

export const MIN_REPEAT = 0.01;
export const MAX_REPEAT = 10000;

// 1 = scroll up => zoom in, -1 = scroll up => zoom out
export const WHEEL_DIRECTION = 1;
export const WHEEL_ZOOM_FACTOR = 1.001;
export const BUTTON_ZOOM_FACTOR = 1.25;

/**
 * maximum zoom scale when the slider is all the way to the left or right
 * @type {number}
 */
export const SLIDER_ZOOM_FACTOR = 1.7;

export const SELECTION_ZOOM_FACTOR = 0.03;
